import { useQuery } from "@tanstack/react-query";
import api from "../api/axios";

export function useTiposAsignados(userId: number, enabled: boolean) {
  return useQuery<number[]>({
    queryKey: ["tipos-asignados", userId],
    enabled,
    queryFn: async () => {
      const { data } = await api.get(`/formaciones/tipos-asignados/${userId}`);
      return data;
    },
  });
}
